module.exports = __webpack_public_path__ + "img/hero-shop.29349588.png";